module.exports = __webpack_public_path__ + "static/media/hero.0c974175.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/projects/new-mills-incubator/hero.jpg
// module id = 60
// module chunks = 0